export default theme => ({
  root: {
    padding: theme.spacing(0)
  },
  content: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1)
  },
  progressWrapper: {
    paddingTop: "48px",
    paddingBottom: "24px",
    display: "flex",
    justifyContent: "center"
  },
  pagination: {
    marginTop: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end"
  },
  row: {
    minHeight: "40px",
    display: "flex",
    alignItems: "stretch",
    flexWrap: "wrap",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3)
  },
  spacer: {
    flexGrow: 1
  },
  searchInput: {
    background: theme.palette.background.light
  },
  button: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4)
  },
  listClasses: {
    backgroundColors: "white"
  },
  divider: {
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(0)
  }
});
